import ButtonModel from '@mm/state/model/ButtonModel';

export type MakeFormFiled = (sortOrder: number) => {
  type: string;
  allowFreeTextResponse: boolean;
  body: string;
  buttons: ButtonModel[];
  validationRule: string | null;
  variableId: number | null;
  sortOrder: number;
  response: string;
};

export default class FormField {
  static make: MakeFormFiled = sortOrder => {
    return {
      type: 'quick_question',
      allowFreeTextResponse: true,
      body: '',
      buttons: [],
      validationRule: null,
      variableId: null,
      sortOrder,
      response: '',
    };
  };
}
